<main *ngIf="form">
    <section class="l-container cyber-bausteine-wrapper" *ngIf="currentSeite">

        <!-- Grundbaustein -->
        <article class="cyber-bausteine__card cyber-bausteine__card--grundbaustein">
            <div class="cyber-bausteine__header">
                <div class="card-icon mdi mdi-shield-check"></div>
            </div>
            <div class="cyber-bausteine__body" >
                <div class="cyber-bausteine__checkbox">
                    <input type="checkbox" id="grundbausteinCheckbox" checked disabled>
                    <label for="grundbausteinCheckbox" class="has-check">
                        <span>{{currentSeite.elemente[0].attribut.label}}</span>
                    </label>
                </div>

                <p class="cyber-bausteine__info">
                    {{currentSeite.elemente[1].attribut.label}}
                </p>
            </div>
        </article>

    </section>

    <div class="l-container l-container--l">
        <h1>{{currentSeite.seiteDefinition.label}}</h1>
    </div>

    <section class="l-container cyber-bausteine-wrapper" *ngIf="currentSeite">

        <!-- 1. -->
        <article class="cyber-bausteine__card">
            <div class="cyber-bausteine__header">
                <div class="card-icon mdi mdi-server-security"></div>
            </div>
            <div class="cyber-bausteine__body" >
                <div class="cyber-bausteine__checkbox">
                    <checkbox-element [form]="form" [element]="currentSeite.elemente[2]" class="cyber-bausteine__checkbox_element"></checkbox-element>
                </div>

                <p class="cyber-bausteine__info">
                    <span>{{currentSeite.elemente[3].attribut.label}} </span>
                    <button type="button"
                            class="m-button m-button--link"
                            (click)="showBausteinMehrInfo(currentSeite.elemente[2].name)">Mehr lesen&hellip;</button>
                </p>
            </div>
            <div class="cyber-bausteine__price" *ngIf="bausteinBeitraege">
                <span *ngIf="bausteinBeitraege" >
                    {{bausteinBeitraege.get(currentSeite.elemente[2].name.substring(8)).nettoBeitrag | currency:'EUR':'symbol-narrow' }}
                </span>
            </div>
        </article>

        <!-- 2. -->
        <article class="cyber-bausteine__card">
            <div class="cyber-bausteine__header">
                <div class="card-icon mdi mdi-cloud-off-outline"></div>
            </div>
            <div class="cyber-bausteine__body">
                <div class="cyber-bausteine__checkbox">
                    <checkbox-element [form]="form" [element]="currentSeite.elemente[4]" class="cyber-bausteine__checkbox_element"></checkbox-element>
                </div>

                <p class="cyber-bausteine__info">
                    <span>{{currentSeite.elemente[5].attribut.label}} </span>
                    <button type="button"
                            class="m-button m-button--link"
                            (click)="showBausteinMehrInfo(currentSeite.elemente[4].name)">Mehr lesen&hellip;</button>
                </p>
            </div>
            <div class="cyber-bausteine__price" *ngIf="bausteinBeitraege">
                <span *ngIf="bausteinBeitraege" >
                    {{bausteinBeitraege.get(currentSeite.elemente[4].name.substring(8)).nettoBeitrag | currency:'EUR':'symbol-narrow' }}
                </span>
            </div>
        </article>

        <!-- 3. -->
        <article class="cyber-bausteine__card">
            <div class="cyber-bausteine__header">
                <div class="card-icon mdi mdi-lan-disconnect"></div>
            </div>
            <div class="cyber-bausteine__body">
                <div class="cyber-bausteine__checkbox">
                    <checkbox-element [form]="form" [element]="currentSeite.elemente[6]" class="cyber-bausteine__checkbox_element"></checkbox-element>
                </div>

                <p class="cyber-bausteine__info">
                    <span>{{currentSeite.elemente[7].attribut.label}} </span>
                    <button type="button"
                            class="m-button m-button--link"
                            (click)="showBausteinMehrInfo(currentSeite.elemente[6].name)">Mehr lesen&hellip;</button>
                </p>
            </div>
            <div class="cyber-bausteine__price" *ngIf="bausteinBeitraege">
                <span *ngIf="bausteinBeitraege" >
                    {{bausteinBeitraege.get(currentSeite.elemente[6].name.substring(8)).nettoBeitrag | currency:'EUR':'symbol-narrow' }}
                </span>
            </div>
        </article>

        <!-- 4. -->
        <article class="cyber-bausteine__card">
            <div class="cyber-bausteine__header">
                <div class="card-icon mdi mdi-credit-card-outline"></div>
            </div>
            <div class="cyber-bausteine__body">
                <div class="cyber-bausteine__checkbox">
                    <checkbox-element [form]="form" [element]="currentSeite.elemente[8]" class="cyber-bausteine__checkbox_element"></checkbox-element>
                </div>

                <p class="cyber-bausteine__info">
                    <span>{{currentSeite.elemente[9].attribut.label}} </span>
                    <button type="button"
                            class="m-button m-button--link"
                            (click)="showBausteinMehrInfo(currentSeite.elemente[8].name)">Mehr lesen&hellip;</button>
                </p>
            </div>
            <div class="cyber-bausteine__price" *ngIf="bausteinBeitraege">
                <span *ngIf="bausteinBeitraege" >
                    {{bausteinBeitraege.get(currentSeite.elemente[8].name.substring(8)).nettoBeitrag | currency:'EUR':'symbol-narrow' }}
                </span>
            </div>
        </article>

        <!-- 5. -->
        <article class="cyber-bausteine__card">
            <div class="cyber-bausteine__header">
                <div class="card-icon mdi mdi-office-building"></div>
            </div>
            <div class="cyber-bausteine__body">
                <div class="cyber-bausteine__checkbox">
                    <checkbox-element [form]="form" [element]="currentSeite.elemente[10]" class="cyber-bausteine__checkbox_element"></checkbox-element>
                </div>

                <p class="cyber-bausteine__info">
                    <span>{{currentSeite.elemente[11].attribut.label}} </span>
                    <button type="button"
                            class="m-button m-button--link"
                            (click)="showBausteinMehrInfo(currentSeite.elemente[10].name)">Mehr lesen&hellip;</button>
                </p>
            </div>
            <div class="cyber-bausteine__price" *ngIf="bausteinBeitraege">
                <span *ngIf="bausteinBeitraege" >
                    {{bausteinBeitraege.get(currentSeite.elemente[10].name.substring(8)).nettoBeitrag | currency:'EUR':'symbol-narrow' }}
                </span>
            </div>
        </article>

    </section>

    <vhv-footer (next)="onSubmit()" [next-disabled]="!areControlsValid" [page-reused]="isPageReused"></vhv-footer>
</main>
